module.exports = __webpack_public_path__ + "static/media/9DESA23.25e0cd9c.jpg";